import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import internalState from './internalState';
import { BorderedCard, FlexBoxWrapper, FlexCenterWrapper, Mt4, Mr3 } from 'wrappers';
import { TitleInput, ClickableIcon } from 'atoms';
import { InputWithIcon, IconTextButton } from 'molecules';
import { ModalCloseButton, PlusSignSvg } from 'components/icons';
import InspectionTemplateOptionsDropdown from '../inspectionTemplateOptionsDropdown';

export const definition = {
  name: 'CategoryPanel',
  controller: Controller,
  initialProps: ({ category, hasCharges }) => ({ category, hasCharges }),
  props: internalState,
  elements: [
    {
      wrapper: BorderedCard,
      name: 'Wrapper',
      displayState: ({ }) => ({ borderRadius: '8px', padding: '21px', background: '#FFFFFF' }),
      elements: [
        {
          component: wrap(TitleInput, FlexBoxWrapper),
          name: 'TitleInput',
          displayState: ({ }) => ({ width: '100%' }),
          bindings: ({ category }) => ({ category, value: category.name ?? '', placeholder: 'Category Title' })
        },
        {
          wrapper: wrap(FlexBoxWrapper, Mt4),
          name: 'ItemWrapper',
          isListOf: 'category.items',
          elements: [
            {
              component: wrap(InputWithIcon, Mr3),
              name: 'Input',
              bindings: ({ item, itemIndex, category }) => ({ category, item, itemIndex, placeholder: 'Item to inspect', value: item.name }),
              displayState: ({ }) => ({ width: '180px' })
            },
            {
              component: wrap(InspectionTemplateOptionsDropdown, Mr3),
              name: 'Dropdown',
              bindings: ({ category, item, itemIndex, hasCharges }) => ({ category, item, selectedOptions: item.options, itemIndex, hasCharges })
            },
            {
              component: ClickableIcon,
              name: 'Delete',
              renderIf: ({ category }) => category?.items?.length > 1,
              displayValue: ({ }) => ModalCloseButton({ width: 22, height: 22, xColor: window?.settings?.primary_color ?? '#1DBD6B' }),
              bindings: ({ category, itemIndex }) => ({ category, itemIndex })
            }
          ]
        },
        {
          component: wrap(wrap(IconTextButton, FlexCenterWrapper), Mt4),
          name: 'AddNewItem',
          bindings: ({ category }) => ({ category, icon: PlusSignSvg({}), title: 'Add Item' })
        },
      ]
    }
  ]
};

export default ContainerComponent(definition);